import React, { createContext, useContext, useState, ReactNode } from 'react'

interface ApplicationSettings {
  globalSearch: {
    enabledSearchType: boolean
    route: {
      id?: string
      title?: string
      forwardUrl?: string
      paramName?: string
    }
  }
}

interface ApplicationSettingsContextProps {
  settings: ApplicationSettings
  updateSettings: (newSettings: Partial<ApplicationSettings>) => void
}

const defaultSettings: ApplicationSettings = {
  globalSearch: {
    enabledSearchType: false,
    route: {}
  }
}

const ApplicationSettingsContext = createContext<ApplicationSettingsContextProps | undefined>(
  undefined
)

export const ApplicationSettingsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<ApplicationSettings>(defaultSettings)

  const updateSettings = (newSettings: Partial<ApplicationSettings>) => {
    setSettings(prevSettings => ({ ...prevSettings, ...newSettings }))
  }

  return (
    <ApplicationSettingsContext.Provider value={{ settings, updateSettings }}>
      {children}
    </ApplicationSettingsContext.Provider>
  )
}

export const useApplicationSettings = (): ApplicationSettingsContextProps => {
  const context = useContext(ApplicationSettingsContext)
  if (!context) {
    throw new Error('useApplicationSettings must be used within an ApplicationSettingsProvider')
  }
  return context
}
